<template>
    <div v-if="signupSuccess">
      <p class="thanks">Thanks for joining the movement!</p>
    </div>
    <form v-else id="email_signup_form" @submit.prevent="checkForm" aria-describedby="form_description">
      <div v-if="postError">
        <p class="errorText">There was an error processing your email sign up. Please fill out all fields and try again.</p>
      </div>

      <div class="field" :class=" { errorField: errors.email }">
        <input type="email" id="id_email" v-model="email" placeholder="Email">
        <label class="screenReaderOnly" for="id_email">Email</label>
        <span v-show="errors.email" class="errorText" aria-live="polite">Not a valid email address</span>
      </div>

      <div>
        <div class="field split left" :class=" { errorField: errors.first_name }">
          <input type="text" id="id_first_name" v-model="first_name" placeholder="First name">
          <label class="screenReaderOnly" for="id_first_name">First name</label>
          <span v-show="errors.first_name" class="errorText" aria-live="polite">
            <span class="screenReaderOnly">First name is </span>Required
          </span>
        </div>
        <div class="field split right" :class=" { errorField: errors.last_name }">
          <input type="text" id="id_last_name" v-model="last_name" placeholder="Last name">
          <label class="screenReaderOnly" for="id_last_name">Last name</label>
          <span v-show="errors.last_name" class="errorText" aria-live="polite">
            <span class="screenReaderOnly">Last name is </span>Required
          </span>
        </div>
      </div>

      <div>
        <div class="field split left" :class=" { errorField: errors.zip }">
          <input type="text" id="id_zip" v-model="zip" placeholder="ZIP code">
          <label class="screenReaderOnly" for="id_zip">ZIP code</label>
          <span v-show="errors.zip" class="errorText" aria-live="polite">
            <span class="screenReaderOnly">Zip code is </span>Required
          </span>
        </div>
        <div class="field split right" :class=" { errorField: errors.phone }">
          <input type="tel" id="id_phone" v-model="phone" placeholder="Phone number">
          <label class="screenReaderOnly" for="id_phone">Phone number</label>
          <span v-show="errors.phone" class="errorText" aria-live="polite">
            <span class="screenReaderOnly">Phone number with area code is </span>Required
          </span>
        </div>
      </div>

      <button type="submit" class="full">I'm in</button>

      <div class="fine_print">
        <p>
          By completing this form, you are joining our People Power volunteer program and agreeing to receive emails, calls, or texts from the ACLU, its state affiliates, and their representatives about ways to take action and support the ACLU, as per our <a href="https://www.aclu.org/american-civil-liberties-union-privacy-statement">privacy policy</a>.
        </p>
      </div>
    </form>
</template>

<script>
import axios from 'axios';

export default {
  props: ['isMobile'],
  data() {
    return {
      signupSuccess: false,
      postError: false,
      errors: {
        email: null,
        first_name: null,
        last_name: null,
        zip: null,
        phone: null
      },
      email: '',
      first_name: '',
      last_name: '',
      zip: '',
      phone: '',
      // Overwritable hidden fields
      hiddenFields: {
        ms: 'voterpledgeapidistricttimemachine',
        initms: 'voterpledgeapidistricttimemachine',
        ms_aff: 'NAT',
        initms_aff: 'NAT',
        ms_chan: 'web',
        initms_chan: 'web',
        ms_ex: null,
        initms_ex: null
      }
    };
  },
  computed: {
    noErrors() {
      let clean = true
      Object.keys(this.errors).forEach(prop => {
        if (this.errors[prop]) {
          clean = false
        }
      })
      return clean
    }
  },
  watch: {
    email() {
      this.checkEmail()
    },
    first_name() {
      this.checkFirstName()
    },
    last_name() {
      this.checkLastName()
    },
    zip() {
      this.checkZip()
    },
    phone() {
      this.checkPhone()
    },
    postError() {
      if (this.postError) {
        this.expanded = true
      }
    }
  },
  mounted() {
    // Check for URL params that will override the form values
    if (document.location.search && document.location.search.length > 0) {
      for (let h in this.hiddenFields) {
        const value = this.getUrlParameter(h)
        if (value) {
          this.hiddenFields[h] = value
        }
      }
    }
  },
  methods: {
    postForm() {
      // API expects formdata, not JSON
      var formData = new FormData();
      formData.append('mail', this.email);
      formData.append('sbp_first_name', this.first_name);
      formData.append('sbp_last_name', this.last_name);
      formData.append('sbp_zip', this.zip);
      formData.append('mobile_phone_number', this.phone);

      // Additional (hidden) fields required by API
      formData.append('email_opt_in', '1');
      formData.append('field_phone_type', 'Cell');
      formData.append('sms_opt_in', '1');
      formData.append('mobile_autodial_opt_in', '1');
      formData.append('cid', '70136000001OtHpAAK');
      formData.append('primary_email_list', 'ActionNational');
      formData.append('secure_prepop_autofilled', 0);
      formData.append('submission_date_time', Math.round(Date.now() / 1000));

      // Update overwritable hidden fields
      for (let field in this.hiddenFields) {
        const val = this.hiddenFields[field]
        if (val) {
          formData.append(field, val)
        }
      }

      const headers = {
        Accept: 'application/json'
      }

      axios
        .post('https://springboard.aclu.org/api-gateway/submit?form_id=34292', formData, { headers })
        .then(({ data, status }) => {
          const response = data[0]
          if (response && status === 200) {
            this.signupSuccess = true;
            this.postError = false;
          } else {
            this.handleFormSubmitError();
          }
        })
        .catch(e => {
          this.handleFormSubmitError();
          console.error(e);
        })
    },
    handleFormSubmitError() {
      this.signupSuccess = false;
      this.postError = true;
      this.focusOnFirstError();
    },
    focusOnFirstError() {
      this.$nextTick().then(() => {
        const errorEl = document.getElementsByClassName('errorField');
        errorEl[0].querySelector('input').focus();
      })
    },
    checkForm() {
      // Double check for errors
      this.checkEmail()
      this.checkFirstName()
      this.checkLastName()
      this.checkZip()
      this.checkPhone()
      // Only submit if no errors
      if (this.noErrors) {
        this.postForm()
      } else {
        this.focusOnFirstError()
      }
    },
    checkEmail() {
      this.errors.email = !this.validateEmail(this.email)
    },
    checkFirstName() {
      this.errors.first_name = !this.first_name.trim().length
    },
    checkLastName() {
      this.errors.last_name = !this.last_name.trim().length
    },
    checkZip() {
      if (this.zip.length < 5) {
        this.errors.zip = !this.isInteger(this.zip)
      } else {
        this.errors.zip = !this.validateZIP(this.zip)
      }
    },
    checkPhone() {
      this.errors.phone = !this.validatePhone(this.phone)
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validateZIP(zip) {
      return /^\b\d{5}(-\d{4})?\b$/.test(zip)
    },
    validatePhone(phone) {
      var re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
      return re.test(phone)
    },
    isInteger(int) {
      return /^\d+$/.test(int)
    },
    getUrlParameter(name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      var results = regex.exec(location.search)
      return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

form {
}
.field {
  position: relative;
  margin: 0 0 0.8em;
}
.field input, button {
  font-size: 18px;
  font-weight: 400;
  padding: 0.7em;
  background: white;
  border: 1px solid white;
  border-radius: 3px;
  width: 100%;
  box-sizing: border-box;
}
.split.left {
  padding-right: 0.25em;
  clear: both;
}
.split.right {
  padding-left: 0.25em;
}
button {
  background: $red;
  color: white;
  border: none;
  font-weight: $bold;
  cursor: pointer;

  &:hover {
    background: lighten($red, 5%)
  }
}
.fine_print {
  font-size: 12px;
}
.errorField input {
  border: 1px solid red;
}
.errorText {
  position: absolute;
  right: 8px;
  top: 5px;
  color: red;
  font-size: 12px;
  font-weight: $bold;
  text-transform: uppercase;
}
.thanks {
  margin: 2rem auto;
  font-weight: bold;
  padding: 0 1rem;
  line-height: 1.5em;
  text-align: center;
}
.mq-mobile {
  .split {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupForm.vue